function VideoNotFound() {
    return <div>VideoNotFound</div>;
}

export default VideoNotFound;
